import { RoutePath } from '@/src/RoutePath';
import { faqSectionRoute } from '@/src/routes';
import { SideNavigation } from '@amzn/awsui-components-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { i18nKeys } from '../../../../utils/i18n.utils';
import { QuestionSections } from '../../faq.config';
import './FAQSidebar.scss';

const faqSections = [
  {
    title: QuestionSections.general.title,
    href: faqSectionRoute.resolvePath('general'),
  },
  {
    title: QuestionSections.host.title,
    href: faqSectionRoute.resolvePath('host'),
  },
  {
    title: QuestionSections.facilitating.title,
    href: faqSectionRoute.resolvePath('facilitating'),
  },
  {
    title: QuestionSections.play.title,
    href: faqSectionRoute.resolvePath('play'),
  },
];

const FAQSidebar = () => {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const [activeHref, setActiveHref] = useState(location.pathname);

  return (
    <div className="faq-sidebar">
      <SideNavigation
        activeHref={activeHref}
        onFollow={(event) => {
          if (!event.detail.external && !event.detail.href.includes('/v1/')) {
            event.preventDefault();
            const newUrl = event.detail.href === '#' ? faqSectionRoute.resolvePath('general') : event.detail.href;
            setActiveHref(newUrl);
            history.push(newUrl);
          }
        }}
        header={{
          href: RoutePath.ROOT,
          text: 'AWS Jam',
        }}
        items={[
          {
            type: 'expandable-link-group',
            text: 'FAQ',
            href: '#',
            items: faqSections.map((section) => ({ type: 'link', text: t(section.title), href: section.href })),
            defaultExpanded: true,
          },
          { type: 'divider' },
          {
            type: 'link',
            text: t(i18nKeys.documentation.title),
            href: RoutePath.DOCUMENTATION,
          },
          {
            type: 'link',
            text: t(i18nKeys.userGuide.title),
            href: RoutePath.USER_GUIDE,
          },
        ]}
      />
    </div>
  );
};

export default FAQSidebar;
